// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kr2a","rootNoMargin":"styles_rootNoMargin__3vI7g"};